jQuery(function() {
    $('.col-content-reference__items .block__row-item').mouseenter(function(){
        $(this).addClass('cr-active');
        if(!$(this).hasClass('cr-active')){
            $('.content-reference-item__preview').slideUp();
        }
        
        $(this).find('.content-reference-item__preview').slideDown();
    })
    $('.col-content-reference__items .block__row-item').mouseleave(function(){
        $(this).removeClass('cr-active');
        $('.content-reference-item__preview').slideUp();
    })
    $('.col-content-reference__items .block__row-item').on('click',function(){
        $(this).find('.content-reference-item__cta a').get(0).click()
    })
});